<template>
    <div class="flex items-center">
        <div class="flex-grow-0 flex-shrink-0 mr-2">
            <input
                :name="name"
                :id="id"
                type="radio"
                :value="value"
                :checked="value === modelValue"
                @input="$emit('update:modelValue', value)"
                class="rounded-full border-2 border-dark w-6 h-6 checked:!bg-primary appearance-none focus:ring-0"
            />
        </div>
        <app-label class="flex-1" :for="id">
            <slot></slot>
        </app-label>
    </div>
</template>

<script>
import AppLabel from '@/Components/Forms/AppLabel.vue';

export default {
    components: {AppLabel},
    emits: ["update:modelValue"],
    props: {
        modelValue: [String, Number, Boolean],
        value: {
            default: null,
        },
        name: String
    },
    computed: {
        id() {
            return (Math.random() + 1).toString(36).substring(7);
        }
    }
};
</script>
